import { Modal } from '@mantine/core';
import useDevice from 'hooks/useDevice';
import React from 'react';

const NotifyFailure = ({ isFail, quantity, name, resson = '', handleClose }) => {
  const isMobile = useDevice().isMobile;

  return (
    <>
      {isMobile ? (
        <Modal
          radius='md'
          withCloseButton={false}
          opened={isFail}
          onClose={handleClose}
          centered
          classNames={{
            root: 'pb-9 pt-7 px-10 z-[1000000]',
            body: 'w-full ',
          }}
        >
          <img className='w-12 h-12 mx-auto mb-2' src='/icon/error.svg' alt='' />
          <p className='text-center'>{resson}!</p>

          <div className='mt-6 w-fit mx-auto'>
            <button
              onClick={handleClose}
              className='uppercase border text-black font-averta-semibold text-13px leading-18px bg-white rounded-4px py-3 px-8'
            >
              Đóng
            </button>
          </div>
        </Modal>
      ) : (
        <div
          className={`absolute z-[1000000] transition-all ${
            isFail ? 'bottom-0' : '-bottom-18'
          } flex w-full items-center bg-[#FFECEF] py-4 px-3`}
        >
          <img className='w-6 h-6 mr-4' src='/icon/error.svg' alt='' />
          <p className='line-clamp-2'>{resson}</p>
        </div>
      )}
    </>
  );
};

export default NotifyFailure;
